import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { object, string } from 'yup';
import { ISINTextField } from '../atomic-components/ISINTextField';
import { InvestmentBasicInformationUploader } from '../atomic-components/InvestmentBasicInformationUploader';
import { InvestmentInformationUploader } from '../atomic-components/InvestmentInformationUploader';
import { InvestmentConditionsUploader } from '../atomic-components/InvestmentConditionsUploader';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';
import { CompanyNameField } from '../atomic-components/CompanyNameField';
import { CompanyDescriptionField } from '../atomic-components/CompanyDescriptionField';
import { AdditionalDocumentsUploader } from '../atomic-components/AdditionalDocumentsUploader';

export const validationSchemaInvestmentTerms = object({
  // Due to Blockchain limitations, we need to limit the ISIN to 16 bytes
  // Simple string validation = Max 12 characters
  // isin: string().length(12, 'ISIN can only be 12 characters long'),
  // Blob validation = Max 16 bytes
  isin: string().test('is-isin', 'ISIN is too long', (value) => {
    if (value) {
      if (new Blob([value]).size <= 16) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }),
});

interface Props {
  disabled: boolean;
}

export const InvestmentTerms: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.investmentterms.title')}>
      <AssetTypeConditional supported={['builderOwnerModel']}>
        <CompanyNameField />
        <CompanyDescriptionField />
      </AssetTypeConditional>
      <ISINTextField disabled={disabled} />
      <AssetTypeConditional supported={['realEstate', 'builderOwnerModel', 'powerplant', 'powerplantPortfolio', 'plot']}>
        <InvestmentBasicInformationUploader disabled={disabled} />
      </AssetTypeConditional>
      <InvestmentInformationUploader disabled={disabled} />
      <InvestmentConditionsUploader disabled={disabled} />
      <AdditionalDocumentsUploader documentsKey="additionalInvestmentDocuments" disabled={disabled} />
    </LaunchpadCard>
  );
};
